import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import * as actions from './milestonesActions';
import { MILESTONE_REDUCER_KEY, type Milestone, type MilestoneProps, type MilestonesStore } from './milestonesTypes';

type GetMilestonesSuccessAction = {
  meta: undefined;
  payload: QcsSyncResourcesPayload<MilestoneProps>;
  type: 'GET_MILESTONES_SUCCESS';
};

type UpdateMilestoneAction = {
  meta: { context?: string } | undefined;
  payload: Milestone[];
  type: 'UPDATE_MILESTONE';
};

type GetMilestonesFailureAction = {
  meta: undefined;
  payload: unknown;
  type: 'GET_MILESTONES_FAILURE';
};

type MilestonesReducerAction = GetMilestonesSuccessAction | GetMilestonesFailureAction | UpdateMilestoneAction;

const mkMilestonesStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<MilestoneProps>();

const milestonesReducer = handleActions<MilestonesStore, MilestonesReducerAction>(
  {
    [actions.GET_MILESTONES_SUCCESS]: (state: MilestonesStore, { payload }: GetMilestonesSuccessAction) =>
      resourceUpserters.upsertResources<MilestoneProps>(state, payload),
    [actions.GET_MILESTONES_FAILURE]: (state: MilestonesStore, { payload }: GetMilestonesFailureAction) =>
      resourceUpserters.completeWithError<MilestoneProps>(state, payload),
    [actions.UPDATE_MILESTONE]: (state: MilestonesStore, { payload }: UpdateMilestoneAction) =>
      resourceUpserters.upsertResources<MilestoneProps>(state, { resources: payload }),
  },
  mkMilestonesStore(),
);

export { MILESTONE_REDUCER_KEY };
export default milestonesReducer;
